import { AccountsEntity } from '@/domain/entities/account';
import { ResetMfaPayload } from '@/domain/ports/account/payloads';
import { AccountsRepository } from '@/domain/ports/account/repositories';

export class ResetMfaUseCase {
  constructor(private readonly repository: AccountsRepository) {}

  async run(payload: ResetMfaPayload): Promise<AccountsEntity> {
    const account = await this.repository.resetMfa(payload);

    return account;
  }
}
